const feedback = {
  namespaced: true,
  state: {
    userMessageDialogVisible: false,
  },
  mutations: {
    updateUserMessageDialogVisible(state, value) {
      state.userMessageDialogVisible = value
    },
  },
  actions: {
    toggleDialogVisible({ commit, state }) {
      commit('updateUserMessageDialogVisible', !state.userMessageDialogVisible)
    },
  },
}

export default feedback
